import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Bounce, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routes from './routes';
import GlobalStyle from './styles/global';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <ToastContainer
        autoClose={3500}
        position="top-right"
        limit={5}
        transition={Bounce}
      />
      <Routes />
      <GlobalStyle />
    </BrowserRouter>
  );
}

export default App;
